// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root,
body {
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden;
}

body {
  display: flex;
  background: var(--color-bg-app);
}

/* Main Layout Grid */
#sidebar {
  width: var(--sidebar-width);
  flex-shrink: 0;
}

#main {
  flex: 1;
  min-width: 0;
}

#details {
  width: var(--details-panel-width);
  flex-shrink: 0;
  display: none; /* Hidden by default, shown when task selected */
}

#details.show {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,aAAa,EAAE,gDAAgD;AACjE;;AAEA;EACE,cAAc;AAChB","sourcesContent":["#root,\nbody {\n  margin: 0;\n  padding: 0;\n  height: 100vh;\n  overflow: hidden;\n}\n\nbody {\n  display: flex;\n  background: var(--color-bg-app);\n}\n\n/* Main Layout Grid */\n#sidebar {\n  width: var(--sidebar-width);\n  flex-shrink: 0;\n}\n\n#main {\n  flex: 1;\n  min-width: 0;\n}\n\n#details {\n  width: var(--details-panel-width);\n  flex-shrink: 0;\n  display: none; /* Hidden by default, shown when task selected */\n}\n\n#details.show {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
